import React, { useContext, useEffect, useState } from 'react'
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { HelpdeskContext } from './Helpdesk';
import { ContentBodyContext } from './../MainContent';
import TextareaAutosize from 'react-textarea-autosize';
import jwt from 'jwt-decode'
import swal from 'sweetalert'


function ChatFooter() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const { stateHelpdesk, dispatchHelpdesk } = useContext(HelpdeskContext);

    const handleSubmit = (event) => {
        event.preventDefault()
        if (dataForm.message != '' && !dataForm.isSubmitting) {
            setDataForm({
                ...dataForm,
                isSubmitting: true,
                icon: 'fas fa-spinner fa-pulse'
            })
            const jwtHelpdesk = jwt(localStorage.getItem('token-helpdesk-umy'))
            stateContentBody.socket.emit(`helpdesk-chat`, {
                id: jwtHelpdesk.work_unit_id,
                token: localStorage.getItem('token-helpdesk-umy'),
                action: 'message',
                data: {
                    username: jwtHelpdesk.status,
                    message: dataForm.message,
                    parent_chat: stateHelpdesk.active,
                    chat_type: { sender: 'admin', type: (stateHelpdesk.chats.find(chat => chat.complaint_id == stateHelpdesk.active).employee_id != null ? 'staff' : 'student') },
                    work_unit: jwtHelpdesk.work_unit_id,
                    file: null,
                    mimetype: null,
                    profile: {
                        status: jwtHelpdesk.role_id == 'student' || jwtHelpdesk.role_id == 'staff' ? jwtHelpdesk.role_id : 'admin',
                        id: jwtHelpdesk.id
                    }
                }
            })
        } else {
            swal("Error!", `Type your message before sending it!`, "error", {
                button: "OK",
            });
        }
    }

    const handleInputChange = (event) => {
        setDataForm({
            ...dataForm,
            message: event.target.value,
            icon: event.target.value == '' ? `far fa-keyboard` : `far fa-paper-plane`
        })
    }

    const handleAttchClick = (event) => {
        event.preventDefault();
        dispatchHelpdesk({
            type: "MODALATTACH",
            modalattach: {
                status: !stateHelpdesk.modalattach.status,
                event: event
            }
        })
    }

    const initialDataForm = {
        message: "",
        isSubmitting: false,
        icon: 'far fa-keyboard',
    }
    const [dataForm, setDataForm] = useState(initialDataForm)

    useEffect(() => {
        setDataForm(initialDataForm)
    }, [stateHelpdesk.active])

    useEffect(() => {
        // if (stateMessage.trigger.message == "helpdesk-chat" && stateMessage.trigger.action.name == 'footer') {
        if (stateHelpdesk.trigger.message == "helpdesk-chat-admin") {
            if (stateHelpdesk.trigger.data == 'success') {
                setDataForm({
                    ...dataForm,
                    message: "",
                    isSubmitting: false,
                    icon: 'far fa-keyboard',
                })
            } else {
                setDataForm({
                    ...dataForm,
                    message: "",
                    isSubmitting: false,
                    icon: 'far fa-paper-plane',
                })
            }
        }
    }, [stateHelpdesk.trigger])

    const initialState = (
        <Fragment>
            <div className="card-footer chat-form">
                <form id="chat-form2" >
                    <div style={{ height: '50px' }}>
                    </div>
                </form>
            </div>
        </Fragment>
    )
    const [renderFooter, setrenderFooter] = useState(initialState)
    useEffect(() => {
        if (stateHelpdesk.active != null && stateHelpdesk.chat.length > 0) {
            if (stateHelpdesk.filterSub == "done") {
                setrenderFooter(initialState)
            } else {
                setrenderFooter(
                    <Fragment>
                        <div className="card-footer chat-form" >
                            <form id="chat-form2" onSubmit={handleSubmit}>
                                <TextareaAutosize minRows={1} maxRows={4} disabled={dataForm.isSubmitting} type="text" className="form-control " placeholder="Type a message..." id="message" name="message" value={dataForm.message} onChange={handleInputChange} style={{ paddingRight: '10%' }} />
                                <button type="button" className="btn btn-danger attachment" onClick={handleAttchClick}>
                                    <i className="fa fa-paperclip" style={{ fontSize: '1.2em' }}></i>
                                </button>
                                <button type="submit" disabled={dataForm.message == "" ? true : dataForm.isSubmitting} className="btn btn-primary submit">
                                    <i className={dataForm.icon} style={{ fontSize: '1.2em' }} ></i>
                                </button>
                            </form>
                        </div>
                    </Fragment>
                )
            }
        } else setrenderFooter(initialState)
    }, [dataForm, stateHelpdesk.active, stateHelpdesk.chat])

    return (renderFooter)
}

export default ChatFooter
